import classNames from 'classnames'
import isNumber from 'lodash/isNumber'
import React, { FC } from 'react'
import { Column } from '../../../models/column'
import * as css from './Cell.css'
import { stores } from '@stores'
import { View } from '@modules/order/constants/views'
import { CATEGORY_INTERNAL_SEPERATOR } from '@modules/order/constants/uiConstants'

export interface CellProps {
  column?: Column
  rowData?: any
  id?: string
}

interface PrivateCellProps {
  stickyPosition?: number
  offset: number
  enhancedViewCell?: boolean
}

const Cell: FC<CellProps & PrivateCellProps> = ({
  column,
  rowData,
  stickyPosition,
  id,
  enhancedViewCell
}) => {
  const {
    hierarchyRowCellTemplate: HeaderCellElement,
    label,
    showHeader = true,
    width,
    showBorders = false,
    showHierarchyBorder = false,
    key,
    isStickyBorder = false
  } = column
  const {
    productConfiguration: { enhancedViewEnabled },
    nav: {
      queryParams: { view }
    }
  } = stores
  const isMainHeirarchy = !id?.includes(CATEGORY_INTERNAL_SEPERATOR)
  return showHeader ? (
    <div
      className={classNames(css['hierarchy-cell'], 'commonBodyCellOverride', {
        [css['sticky-cell']]: isNumber(stickyPosition),
        [css['cell-border']]:
          !enhancedViewCell &&
          !enhancedViewEnabled &&
          !isStickyBorder &&
          (showBorders || showHierarchyBorder),
        [css['enhanced-sticky']]: enhancedViewCell && key && isNumber(stickyPosition),
        [css['enhanced-cell-border']]:
          enhancedViewCell && !key && (showBorders || showHierarchyBorder),
        [css['enhanced-sticky-header']]: isStickyBorder,
        [css['enhancedRowCellBorder']]:
          enhancedViewEnabled && !enhancedViewCell && showBorders && view !== View.KPI,
        [css['enhancedMainHierarchy']]:
          isMainHeirarchy && enhancedViewEnabled && view === View.KPI
      })}
      style={{
        width: width || '100%',
        minWidth: width,
        left: stickyPosition
      }}
    >
      {HeaderCellElement ? (
        <HeaderCellElement column={column} rowData={rowData} id={id} />
      ) : (
        label
      )}
    </div>
  ) : null
}

export default Cell
